import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { Reveal, SectionHeading, StatusBadge } from "./Section";

const Fundraising = ({ onEnquire }) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/fundraising").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <section id="fundraising" className="relative py-28 md:py-36 bg-[#0C0F16]" data-testid="fundraising-section">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <SectionHeading index="07" eyebrow="Fundraising" title="Building capital around ideas that matter." subtitle="Some businesses begin with capital. Others begin with a problem. I prefer to begin with the problem — then Problem → Vision → Technology → People → Validation → Capital → Scale." />
        <div className="grid gap-5 md:grid-cols-2">
          {items.map((f, i) => (
            <Reveal key={f.id} delay={i * 0.08}>
              <article className="h-full rounded-2xl border border-[#E2C08D]/20 bg-gradient-to-br from-[#14161f] to-[#10141d] p-8" data-testid={`fundraise-card-${f.company.toLowerCase().replace(/\s+/g, "-")}`}>
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <h3 className="font-display text-3xl font-semibold text-slate-100">{f.company}</h3>
                    <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.22em] text-slate-500">{f.sector}</p>
                  </div>
                  <StatusBadge accent="gold">{f.status}</StatusBadge>
                </div>
                <dl className="mt-7 space-y-4 text-sm">
                  {[["Stage", f.stage], ["Raising", f.capital], ["Use of funds", f.use_of_funds], ["Traction", f.traction]].map(([k, v]) => v && (
                    <div key={k} className="flex gap-4 border-b border-white/5 pb-3">
                      <dt className="w-28 shrink-0 font-mono text-[11px] uppercase tracking-[0.18em] text-slate-500 pt-0.5">{k}</dt>
                      <dd className="text-slate-300 leading-relaxed">{v}</dd>
                    </div>
                  ))}
                </dl>
                <p className="mt-5 font-display italic text-lg text-[#E2C08D]/90">{f.opportunity}</p>
                <button onClick={() => onEnquire("fundraising", f.company)} data-testid={`fundraise-enquire-${f.company.toLowerCase().replace(/\s+/g, "-")}`} className="group mt-7 inline-flex items-center gap-2 rounded-full bg-[#E2C08D] px-6 py-3 text-sm font-semibold text-[#0A0C10] hover:bg-[#f0d3a4] transition-colors">
                  View Opportunity <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
                </button>
              </article>
            </Reveal>
          ))}
        </div>
        {items.length === 0 && <p className="text-slate-500 text-sm" data-testid="fundraise-empty">New opportunities will be announced here soon.</p>}
      </div>
    </section>
  );
};

export default Fundraising;
